import React, {Fragment} from "react";
import ListView from "../../../components/ContentDisplay/ListView";
import {JobsCard} from "./jobsCard";
import {LIST_HEADERS} from "./jobsTable.constants";
import {useJobsTableData} from "./useJobsTableData";

const JobsTable = () => {
  const {jobs, paginationConfig, totalCount} = useJobsTableData();
  return (
    <Fragment>
      <ListView
        listItems={jobs}
        listHeaders={LIST_HEADERS}
        cardContent={JobsCard}
        totalCount={totalCount}
        withPagination={paginationConfig}
      />
    </Fragment>
  );
};

export default JobsTable;
